import Vue from 'vue'
import VueHead from 'vue-head'
import BootstrapVue from 'bootstrap-vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import axios from 'axios'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/styles/common.scss'
import 'swiper/dist/css/swiper.css'

import App from '@/App.vue'
import store from '@/store/store'
import router from '@/router'
import i18n from '@/i18n'

Vue.use(BootstrapVue)
Vue.use(VueHead, {
  complement: i18n.t('siteId'),
})
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
Vue.prototype.$axios = axios

if (process.env.VUE_APP_MODE === 'local') {
  const mock = async () => await import(/* webpackChunkName: "mock" */ '@/../mock')
  mock().then(() => {
    new Vue({
      router,
      store,
      i18n,
      render: (h) => h(App),
    }).$mount('#app')
  })
} else {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app')
}
